import { BranchModel } from '../management/branch.model';
import { ConceptInvoicingModel } from './concept-invoicing.model';
import { InvoiceModel } from './invoice.model';

export class AdvanceInvoiceConceptModel {
  advanceInvoiceConceptId: number = 0;
  invoiceId: number = 0;
  invoice: InvoiceModel = new InvoiceModel();
  branchId: number = 0;
  branch: BranchModel = new BranchModel();
  conceptInvoicingId: number = 0;
  conceptInvoicing: ConceptInvoicingModel = new ConceptInvoicingModel();
  swStore: boolean = false;
  differenceValue: number = 0;
  differenceValueFinal: number = 0;
  createDate: string = "";
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;
}